<template>      
  <v-app-bar app :color="$config.theme.primaryColor" dark dense
  >      
      <v-app-bar-nav-icon @click.stop="handleLeftDrawerToggle"><v-icon>reorder</v-icon></v-app-bar-nav-icon>      
      
      <!--<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
          <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-btn dark icon @click.stop="handleLeftMiniVariant">
          <v-icon v-html="miniVariant ? 'fa-angle-right fa-lg' : 'fa-angle-left fa-lg'"></v-icon>
      </v-btn>-->
      <!--<v-btn icon @click.stop="handleLeftClipped">
          <v-icon>fa-archive</v-icon>
      </v-btn>-->                
      <!--<v-btn icon @click.stop="fixed = !fixed">
          <v-icon>remove</v-icon>
      </v-btn>-->
      <!--<v-toolbar-title v-text="title"></v-toolbar-title>-->
      <!--<v-btn dark icon href="../">
        <v-icon>view_module</v-icon>
      </v-btn>-->
      <v-spacer></v-spacer>
      <!--<v-btn dark @click="prevPage()" icon><v-icon>arrow_back</v-icon></v-btn>
      <v-btn dark :disabled="disabledforward" @click="nextPage()" icon><v-icon>arrow_forward</v-icon></v-btn>-->        
      <v-menu bottom offset-y open-on-hover transition="scale-transition">
        <template v-slot:activator="{ on }" >
          <v-btn dark icon v-on="on" large>
            <v-avatar size="40px" :color="$config.theme.accentColor">
              <img v-if="user.thumb" :src="user.thumb" :alt="user.username" @error="imgUrlAlt" />
              <span v-else class="white--text">{{user.username ? user.username.charAt(0):null}}</span>
            </v-avatar>          
          </v-btn>
        </template>
        <v-list>          
          <v-list-item class="py-2" v-bind:to="{path:'/profile/'}">
            <v-list-item-avatar :color="$config.theme.accentColor">
              <img v-if="user.thumb" :src="user.thumb" :alt="user.username"  @error="imgUrlAlt"/>
              <span v-else class="white--text">{{user.username ? user.username.charAt(0):null}}</span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="black--text"><strong>{{user.username}}</strong></v-list-item-title>              
              <small>
                {{user.roles}}
              </small>              
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-item-icon v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>   
      </v-menu>
      <!--<v-toolbar-side-icon dark @click.stop="handleRightDrawerToggle"></v-toolbar-side-icon>  -->      
  </v-app-bar>  
</template>
<script>
import config from '@/app/config'; 
//import Notif  from '@/utils/models/Notif';
import Util   from '@/utils';
import user   from '@/utils/models/User';
//import Model  from '@/app/models/User';

//const notif = new Notif();
//const model = new Model();

export default {
  name: 'app-toolbar',
  data: () => ({
    disabledforward : false,
    color:config.color,
    notifLength:0,
    title: 'Biz4',
    miniVariant:false,
    clipped: false,
    drawer: true,
    fixed: false,
    rightDrawer: false,
    right: true,
    user : user.attributes(),
    prevUrl : null,
    items: [      
      {
        icon: 'settings',
        href: '#',
        title: 'Settings',
        click: (/*e*/) => {     
            window.getApp.$emit('APP_OPEN_DIALOG_SETTING');        
        }
      },
      {
        icon: 'exit_to_app',
        href: '#',
        title: 'Logout',
        click: (/*e*/) => {
            window.getApp.$emit('APP_LOGOUT');
            window.getApp.$emit('showSnackbar', {
                show:true,
                text:'Logout Succesfully.',
                color:'green'
            });
        }
      }
    ],
  }),  
  asyncComputed: {    
    profile(){
      /*return model.profile().then(res=>{        
        return res.data;        
      });*/
      return {};
    },        
  },
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  created () {
    //this.user.thumb = this.$config.file('user-thumb', this.user.id);
    /*var context = this;
    
    context.$store.watch(
        function (state) {
            return state;
        },
        function () {
            notif.all().then(data => {      
                context.notifLength = data.length;                
            });  
        },
        {
            deep: true //add this if u need to watch object properties change etc.
        }
    );*/         
  },  
  methods: {
    handleRightDrawerToggle () {
      window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED');      
    },
    handleLeftDrawerToggle () {
      window.getApp.$emit('APP_LEFT_DRAWER_TOGGLED');      
    },
    handleLeftMiniVariant () {
      window.getApp.$emit('APP_LEFT_MINI_VARIANT'); 
      this.miniVariant = (!this.miniVariant);
    },
    handleLeftClipped () {
      window.getApp.$emit('APP_LEFT_CLIPPED');   
      this.clipped = (!this.clipped);
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    goMarket(){
      //ls.set('apps','main');
      this.$router.push({ path: './' });
      //this.$router.replace({path:'/'});
      //this.$router.go(0);
    },    
    nextPage(){            
      this.$router.go(1);
      if(this.prevUrl === this.$route){
        this.disabledforward = true;
      }            
      this.prevUrl = this.$route;
    },
    prevPage(){
      this.$router.go(-1);
      this.disabledforward = false;                  
      this.prevUrl = this.$route;
    },    

    imgUrlAlt(event){
      event.target.src = require('@/app/assets/logo.png');
    }
  }
};
</script>
